module.exports = __webpack_public_path__ + "img/shorts.3c9ec64f.svg";